import { Component } from '@angular/core';

@Component({
  selector: 'pc-circle-group-4',
  standalone: true,
  imports: [],
  templateUrl: './circle-group-4.component.html',
  styleUrl: './circle-group-4.component.scss'
})
export class CircleGroup4Component {

}
